import React from 'react'

const Home = () => {
    return (
        <>
            <div className="container">
                <div className="row">
                    <div className=" col-lg-4 col-md-9 col-sm-12 col-12  col-sm-5 px-3 px-sm-0">
                        <div className="card van">
                            <img className="img-fluid"
                                src="https://images.unsplash.com/photo-1490481651871-ab68de25d43d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fGZhc2hpb258ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60"
                                className="card-img-top" alt="..." />
                            <div className="card-body">
                                <h2 className="card-title"> mens style</h2>
                                <p>20 dec 2020 </p>
                                <p className="card-text">
                                    <br /> <br />Lorem ipsum dolor sit amet consectetur adipisicing elit. Quam consectetur, est
                                    numquam ex veniam
                                    odio dicta voluptatem natus hic soluta iure omnis. Adipisci unde ab iure natus sint quidem
                                    itaque. <br />
                                    content.
                                </p>
                                <a href="#" className="btn btn-light">Read more</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="e">
                <p>Great Style For Everyone</p><br />
                <h1>I Love To Help People Feel Great About How They Look.</h1>
            </div>

            <div className="carb mb-3 max-width: 1500px;">
                <div className="row g-0">
                    <div className="col-md-8">
                        <img src="https://images.unsplash.com/photo-1574201635302-388dd92a4c3f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTl8fGZhc2hpb258ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60"
                            className="img-fluid rounded-start" alt="..." />
                    </div>
                    <div className="col-md-4">
                        <div className="card-body">
                            <h5 className="card-title">SUSTAINABLE FASHION</h5>
                            <p className="card-text">“Never buy anything that’s less than fabulous. Then you’ll wear it over and
                                over again!”

                                I often remember the words of Carrie Bradshaw’s character in Sex and the City before I buy
                                something. She might not have meant it that way, but for me, it represents everything
                                sustainable fashion in India is about.This is a wider card with supporting text below as a
                                natural lead-in to additional content. Do you impulsively buy new clothes that are
                                environmentally harmful, water intensive, exploit humans, abuse animals and have a small shelf
                                life?

                                Or do you consciously invest in clothing brands that are mindful of the resources they use,
                                refrain from using animal products, pay fair wages and last a lifetime?This content is a little
                                bit longer.</p>
                            <p className="card-text"><small className="text-muted">Last updated 3 mins ago</small></p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <article className="uk-article">

                    <h1 className="uk-article-title"><a className="uk-link-reset" href="">How to make sustainable fashion choices in
                        India</a></h1>

                    <p className="uk-article-meta">Written by <a href="#">Super User</a> on 12 April 2022. Posted in <a
                        href="#">Blog</a></p>

                    <p className="uk-text-lead">Given the obvious urgency to switch to more eco-friendly, ethical and conscious
                        fashion, here are some ways I’ve learnt to embrace sustainable fashion in India:</p>

                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                        dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
                        ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
                        fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia
                        deserunt mollit anim id est laborum.</p>

                    <div className="uk-grid-small uk-child-width-auto" uk-grid>
                        <div>
                            <a className="uk-button uk-button-text" href="#">Read more</a>
                        </div>
                        <div>
                            <a className="uk-button uk-button-text" href="#">5 Comments</a>
                        </div>
                    </div>

                </article>
            </div>

        </>
    )
}

export default Home
